import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { HttpService } from '../../../../services/http.service';
import { TreeNode } from 'primeng/primeng';
import { Globals } from '../../../../globals/Globals';
import { Http } from '@angular/http';

@Component({
  selector: 'app-session-detail-report',
  templateUrl: './session-detail-report.component.html',
  styleUrls: ['./session-detail-report.component.css'],
})
export class SessionDetailReportComponent {
  pdfSrc = '';

  venueGroupsTree: TreeNode[];
  venueGroups;
  selectedVenueGroup;
  venueGroup;
  periods;
  selectedPeriod;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private httpService: HttpService,
    private http: Http,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Dashboard' },
      {
        label: 'Session Detail Report',
        routerLink: [{ outlets: { sub: [RouterConst.SESSION_DETAIL_REPORT] } }],
      },
    ]);

    httpService.getPDFPeriods().subscribe((data: any) => {
      this.periods = data.payload;
    });

    httpService.getPDFLocGroups().subscribe((data: any) => {
      this.venueGroupsTree = JSON.parse(data.payload);
    });

    httpService.getVenueGroups().subscribe((data: any) => {
      console.log('data ' + data.payload);
      this.venueGroups = data.payload;
    });
  }

  buildPDF() {
    this.pdfSrc =
      Globals.SERVER_ADDR +
      '/reports/pdf/getReport?venueGroup=' +
      this.venueGroup.venueGroup +
      '&month=' +
      this.selectedPeriod.month +
      '&year=' +
      this.selectedPeriod.year;
  }

  download() {
    window.open(
      this.pdfSrc +
        '&filename=' +
        this.venueGroup.description +
        ' ' +
        this.selectedPeriod.description +
        '.pdf',
    );
  }

  onVenueGroupSelect(e) {
    this.venueGroup = this.venueGroups.filter(el => {
      return el.id === e.node.id;
    })[0];
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/dashboards/reporting/session-detail-report/session-detail-report.component.ts